export default "__VITE_ASSET__4bb65d0f__"